"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const HeaderComponent_1 = require("../../commonFiles/PageComponents/HeaderComponent");
const ParagraphComponent_1 = require("../../commonFiles/PageComponents/ParagraphComponent");
const TitleComponent_1 = require("../../commonFiles/PageComponents/TitleComponent");
const ImageComponent_1 = require("../../commonFiles/PageComponents/ImageComponent");
const LinkComponent_1 = require("../../commonFiles/PageComponents/LinkComponent");
const YoutubeEmbedComponent_1 = require("../../commonFiles/PageComponents/YoutubeEmbedComponent");
const SeperatorComponent_1 = require("../../commonFiles/PageComponents/SeperatorComponent");
const QuoteComponent_1 = require("../../commonFiles/PageComponents/QuoteComponent");
const structure_1 = require("../../commonFiles/PageComponents/structure");
const paragraphsComponent = 'فقرات متتالية';
const componentsTypes = {
    [structure_1.ParagraphComponentClass]: { label: 'نص عادي', Creator: ParagraphComponent_1.ParagraphComponentCreator },
    [paragraphsComponent]: { label: 'فقرات متتالية', Creator: ParagraphComponent_1.ParagraphsComponentCreator },
    [structure_1.HeaderComponentClass]: { label: 'عنوان فرعي', Creator: HeaderComponent_1.HeaderComponentCreator },
    [structure_1.TitleComponentClass]: { label: 'عنوان صفحة', Creator: TitleComponent_1.TitleComponentCreator },
    [structure_1.ImageComponentClass]: { label: 'صورة', Creator: ImageComponent_1.ImageComponentCreator },
    [structure_1.LinkComponentClass]: { label: 'رابط', Creator: LinkComponent_1.LinkComponentCreator },
    [structure_1.YoutubeEmbedComponentClass]: { label: 'رابط فيديو', Creator: YoutubeEmbedComponent_1.YoutubeEmbedComponentCreator },
    [structure_1.SeperatorComponentClass]: { label: 'فاصل', Creator: SeperatorComponent_1.SeperatorComponentCreator },
    [structure_1.QuoteComponentClass]: { label: 'اقتباس', Creator: QuoteComponent_1.QuoteComponentCreator },
    JsonFormat: { label: 'Json', Creator: JsonFormatField }
};
function JsonFormatField(props) {
    const dispatch = props.dispatch;
    const [json, setjson] = react_1.default.useState();
    const [scrollHeight, setscrollHeight] = react_1.default.useState(300);
    return react_1.default.createElement("textarea", { style: {
            borderWidth: 1,
            width: '100%',
            height: scrollHeight
        }, dir: 'ltr', onChange: (e) => {
            setjson(e.target.value);
            setscrollHeight(e.target.scrollHeight);
            dispatch(JSON.parse(`[${e.target.value}]`));
        }, value: json !== null && json !== void 0 ? json : '' });
}
function PageComponentsCreator(props) {
    const addComponent = props.addComponent;
    const [SelectedType, setSelectedType] = react_1.default.useState();
    const [component, setcomponent] = react_1.default.useState(null);
    // React.useEffect(() => {
    //     if (component)
    //         console.log('PageComponentsCreator component', component)
    // }, [component])
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_bootstrap_1.Col, { xs: 2, className: 'mx-auto' },
            react_1.default.createElement(react_bootstrap_1.Dropdown, { onSelect: (e) => { setSelectedType(componentsTypes[e]); setcomponent(null); } },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "success" }, "\u0627\u062E\u062A\u0631 \u0646\u0648\u0639 \u0627\u0644\u0639\u0646\u0635\u0631"),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null, Object.keys(componentsTypes).map(function (key, index) {
                    return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: index, eventKey: key }, componentsTypes[key].label);
                })))),
        SelectedType ? react_1.default.createElement(SelectedType.Creator, { dispatch: (component) => setcomponent(component) }) : null,
        react_1.default.createElement(react_bootstrap_1.Col, { xs: 1, className: 'mx-auto' }, component ?
            react_1.default.createElement(react_bootstrap_1.Button, { className: 'my-2', onClick: () => {
                    if (!Array.isArray(component)) {
                        addComponent(component);
                        setcomponent(null);
                        setSelectedType(null);
                    }
                    else {
                        console.log('components', component);
                        component.forEach(element => {
                            addComponent(element);
                        });
                        setcomponent(null);
                        setSelectedType(null);
                    }
                }, variant: "primary" }, "\u0627\u0636\u0641")
            : null)));
}
exports.default = PageComponentsCreator;
